import { BarChart3 } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { CdnConsoleBreadcrumbs } from './CdnConsoleBreadcrumbs';
import { MonitoringTab } from '../analytics/tabs/MonitoringTab';
import { ServiceOverviewTab } from '../analytics/tabs/ServiceOverviewTab';
import { ViewerLocationTab } from '../analytics/tabs/ViewerLocationTab';

export type CdnAnalyticsView = 'monitoring' | 'overview' | 'location';

const VIEW: Record<CdnAnalyticsView, { title: string; description: string; Tab: typeof MonitoringTab }> = {
  monitoring: {
    title: 'Monitoring',
    description: 'Live edge traffic at the finest granularity for this CDN service.',
    Tab: MonitoringTab,
  },
  overview: {
    title: 'Service Overview',
    description: 'Aggregate traffic, cache efficiency and response health for this CDN service.',
    Tab: ServiceOverviewTab,
  },
  location: {
    title: 'Viewer Location',
    description: 'Where your audience is — request and volume share by country.',
    Tab: ViewerLocationTab,
  },
};

/**
 * Service-scoped analytics view rendered as a dedicated route inside the CDN
 * console. Each view (Monitoring / Service Overview / Viewer Location) is its
 * own nav child under Analytics. Tabs read the serviceId from the URL and fetch
 * service-scoped data, so no project filter is needed here.
 */
export function CdnAnalyticsPage({ view }: { view: CdnAnalyticsView }) {
  const { title, description, Tab } = VIEW[view];

  return (
    <Container size="xl">
      <PageHeader
        icon={<BarChart3 size={22} />}
        breadcrumbs={
          <CdnConsoleBreadcrumbs trail={[{ label: 'Analytics', slug: 'analytics' }, { label: title }]} />
        }
        title={title}
        description={description}
      />
      <Tab />
    </Container>
  );
}
